import { create } from 'zustand';

export interface Toast {
  id: string;
  title?: string;
  body: string;
  variant?: 'info' | 'success' | 'error';
  timeoutMs?: number;
}

interface UIState {
  toasts: Toast[];
  pushToast: (t: Omit<Toast, 'id'>) => string;
  dismissToast: (id: string) => void;
}

export const useUIStore = create<UIState>((set, get) => ({
  toasts: [],
  pushToast: (t) => {
    const id = crypto.randomUUID();
    set({ toasts: [...get().toasts, { id, ...t }] });
    const ms = t.timeoutMs ?? 4000;
    if (ms > 0) {
      setTimeout(() => get().dismissToast(id), ms);
    }
    return id;
  },
  dismissToast: (id) => set({ toasts: get().toasts.filter((x) => x.id !== id) }),
}));
